export default {
  account: {
    '-10086': '请求出错，请检查网络',
    '-1002': '发生错误，请重试',
    '-2000': '发生错误请重试', // 逻辑错误或用户不存在
    '-2001': '短信服务异常',
    '-2002': '敏感词服务异常，请稍后重试',
    '-2003': '钱包服务异常',
    '-3000': '操作过于频繁，请稍后重试', // 验证码发送太频繁
    '-3004': '图形验证码错误', // 图形验证码已失效，请重新获取
    '-3005': '图形验证码错误', // 非法图形验证码
    '-3006': '图形验证码错误',
    '-3007': '短信验证码已失效，请重新获取', // 短信验证码已失效，请重新获取
    '-3008': '非法短信验证码',
    '-3009': '短信验证码不正确',
    '-2010': 'alias 不可用',
    '-2011': '非法 alias',
    '-2100': '非法设备',
    '-3010': '非法电话',
    '-3011': '该账号不存在或密码错误', // 账号不存在
    '-3012': '该手机号已注册',
    '-3013': '用户信息错误',
    '-3014': '新旧手机号一致',
    '-3020': '非法昵称',
    '-3021': '昵称含敏感词，请更换',
    '-3030': '密码格式错误',
    '-3031': '该账号不存在或密码错误',
    '-3032': '非法新密码',
    '-3033': '新旧密码一致',
    '-3040': '重新输入用户基本信息',
    '-3041': '基本信息更新参数错误',
    '-3042': '非法性别',
    '-3043': '非法生日',
    '-3044': '非法学历',
    '-3045': '非法职业',
    '-3046': '非法头像',
    '-3047': '非法 Content-Md5',
    '-3048': 'Content-Md5 错误',
    '-3049': '文件系统错误',
    '-3050': '票据无效，登录状态过期',
    '-3051': '刷新票据',
    '-3052': '平台非法',
    '-3053': '应用 id 非法',
    '-3100': '地址名称非法',
    '-3101': '地址街道非法',
    '-3102': '地址省份非法',
    '-3103': '地址城市非法',
    '-3104': '地址地区非法',
    '-3105': '地址继承关系非法',
    '-3106': '超过用户最大地址数',
    '-3107': '地址 id 非法',
    '-3108': '地址 id 错误',
    '-3109': '地区 id 错误',
    '-4000': '数据库操作错误',
    '-5000': 'type 非法',
    '-5001': 'uniqid 非法',
    '-5002': 'subid 非法',
    '-5003': '该社交账号已被其他账号绑定',
    '-5004': '第三方绑定信息错误'
  },
  main: {
    '-10086': '请求出错，请检查网络',
    '-1002': '系统内部错误',
    '-2021': '专栏可能已下架，不能订阅',
    '-2022': '该专栏不存在',
    '-2023': '专栏已订阅',
    '-2001': '余额账户异常',
    '-2102': '余额不足',
    '-2121': '支付失败'
  }
}
